export default __webpack_public_path__ + "static/media/enkryptWalletIcon.230e4678.svg";